export const notifySettings = {
  width: '320px',
  position: 'right-top',
  distance: '10px',
  opacity: 1,
  fontSize: '14px',
  borderRadius: '12px',
};
